<template>
  <div class="header">
      <SwitchMode />
      <Login />
  </div>
</template>
<script>
import Login from '@/components/Home/Login.vue'
import SwitchMode from '@/components/Home/SwitchMode.vue'
export default {
  name: 'Header',
  components: {
      Login,
      SwitchMode
  },
}
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 40px;
  background: #333;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>